import React from "react";
import App from "./App";
import ReactDOM from "react-dom/client";
 
//const rootElement = document.getElementById("root");
//hydrateRoot(rootElement, <React.StrictMode><App /></React.StrictMode>);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /></React.StrictMode>);